<template>
  <div class="page-card">
    <h2 class="page-title">通告大厅</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="query.keyword"
          placeholder="标题关键字"
          clearable
          style="width: 240px"
        />
        <el-select v-model="query.status" clearable placeholder="状态" style="width: 160px">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" @click="fetchData">查询</el-button>
        <el-button @click="goPrivateMessages">私信管理</el-button>
      </div>
    </div>

    <el-table :data="list" border>
      <el-table-column prop="id" label="通告ID" width="110" />
      <el-table-column prop="submitterName" label="通告标题" min-width="220" />
      <el-table-column label="曝光值" width="110" align="right">
        <template slot-scope="{ row }">{{ row.exposureValue || 0 }}</template>
      </el-table-column>
      <el-table-column prop="submitTime" label="创建时间" width="180" />
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="状态" width="140">
        <template slot-scope="{ row }">
          <el-tag :type="statusTagType(row.status)">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewDetail(row)">查看详情</el-button>
          <el-button v-if="row.status === 5" type="text" @click="changeStatus(row, 'off')">下架</el-button>
          <el-button v-if="row.status === 6" type="text" @click="changeStatus(row, 'on')">上架</el-button>
          <el-button v-if="row.status === 5 || row.status === 6" type="text" @click="changeStatus(row, 'ban')">封禁</el-button>
          <el-button v-if="row.status === 9" type="text" @click="changeStatus(row, 'unban')">解封</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import {
  banCastingNotice,
  getCastingNoticeAudits,
  offShelfCastingNotice,
  onShelfCastingNotice,
  unbanCastingNotice
} from '../../../api/audit'
import { navigateWithFallback } from '../../../utils/admin-navigation'

const statusOptions = [
  { label: '招募中', value: 5 },
  { label: '已下架', value: 6 },
  { label: '已封禁', value: 9 }
]

export default {
  name: 'CastingHallPage',
  data() {
    return {
      list: [],
      query: {
        keyword: '',
        status: 5
      },
      statusOptions
    }
  },
  created() {
    const routeStatus = this.$route.query.status
    if (routeStatus) {
      this.query.status = Number(routeStatus)
    }
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.list = await getCastingNoticeAudits({
        keyword: this.query.keyword || undefined,
        status: this.query.status || undefined
      })
    },
    statusLabel(status) {
      if (status === 5) return '招募中'
      if (status === 6) return '已下架'
      if (status === 9) return '已封禁'
      if (status === 2) return '待审核'
      if (status === 4) return '已驳回'
      return status == null ? '-' : String(status)
    },
    statusTagType(status) {
      if (status === 5) return 'success'
      if (status === 6) return 'warning'
      if (status === 9) return 'danger'
      return 'info'
    },
    viewDetail(row) {
      navigateWithFallback(this, {
        path: `/audits/casting-notice/${row.id}`,
        query: {
          from: 'hall',
          fromStatus: String(this.query.status || 5)
        }
      })
    },
    async changeStatus(row, action) {
      const configMap = {
        off: { text: '下架', api: offShelfCastingNotice },
        on: { text: '上架', api: onShelfCastingNotice },
        ban: { text: '封禁', api: banCastingNotice },
        unban: { text: '解封', api: unbanCastingNotice }
      }
      const config = configMap[action]
      if (!config) return

      if (action === 'ban') {
        let promptResult
        try {
          promptResult = await MessageBox.prompt('请输入封禁原因', '封禁通告', {
            confirmButtonText: '确认封禁',
            cancelButtonText: '取消',
            inputPlaceholder: '请填写审核拒绝/封禁原因',
            inputValidator: value => (value && value.trim() ? true : '请填写封禁原因')
          })
        } catch (e) {
          return
        }
        await config.api(row.id, { remark: promptResult.value.trim() })
        this.$message.success(`${config.text}成功`)
        await this.fetchData()
        return
      }

      try {
        await MessageBox.confirm(`确认${config.text}该通告吗？`, '操作确认', {
          type: 'warning',
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        })
      } catch (e) {
        return
      }
      await config.api(row.id, {})
      this.$message.success(`${config.text}成功`)
      await this.fetchData()
    },
    goPrivateMessages() {
      this.$router.push('/platform/private-messages')
    }
  }
}
</script>
